import { useState } from "react";
import { useRunToolAction } from "../../api/useConnectedTools";
import RunActionDialog from "./RunActionDialog";
import type { ToolActionView } from "../../types";

/** Runs a tool's action, asking first when it needs an answer or a confirmation. */
export function useToolRunner(toolId: number, leadId: number | string | undefined) {
  const run = useRunToolAction(leadId);
  const [asking, setAsking] = useState<ToolActionView | null>(null);

  const start = (action: ToolActionView) => {
    if (action.confirm || action.inputs.length) setAsking(action);
    else run.mutate({ toolId, actionKey: action.key });
  };

  const dialog = asking ? (
    <RunActionDialog
      action={asking}
      isLoading={run.isPending}
      onClose={() => setAsking(null)}
      onRun={(input) => run.mutate({ toolId, actionKey: asking.key, input }, { onSettled: () => setAsking(null) })}
    />
  ) : null;

  return {
    start,
    dialog,
    isPending: run.isPending,
    pendingKey: run.isPending ? run.variables?.actionKey : undefined,
  };
}
